import {
  Box,
  Button,
  CircularProgress,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Table,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Delete_Region } from "../../../../constants";
import axios from "axios";
import { Delete, Trash } from "lucide-react";

const TableComponent = ({ regionList, loading, setLoading, onRefresh}) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    // Slice data for current page
    const paginatedRows = regionList.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [regionName, setRegionName] = useState("");
    const [selectedRegionId, setSelectedRegionId] = useState("");
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleDeleteRegion = async () => {
        if (!selectedRegionId) return;

        try {
            setDeleteLoading(true);
          const response = await axios.delete(
            `${Admin_Parivartan_Delete_Region}/${selectedRegionId}`
          );
    
          if (response.status === 200) {
            console.log("Region deleted successfully");
            setDeleteModalOpen(false);
            onRefresh();
          } else {
            console.error("Failed to delete category");
          }
        } catch (error) {
          console.error("Error deleting category:", error);
        } finally {
            setDeleteLoading(false);
        }
    };

  if (loading) {
    return (
      // <div>Loading region assignments...</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading Region List...</Typography>
      </Box>
    );
  }

  if (!regionList || regionList.length === 0) {
    return (
      // <div>No region assignments found.</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <Typography>No Regions found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>S No.</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Region ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }} width={50}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {regionList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No Regions found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((ro, index) => (
                    <TableRow key={ro.RegionId}>
                      <TableCell>
                        <Typography variant="body2">{index + 1}.</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {ro.RegionId || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {ro.RegionName || "-"}
                        </Typography>
                      </TableCell>

                      <TableCell width={50}>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          startIcon={<Trash size={18} color="red" />}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedRegionId(ro.RegionId);
                            setRegionName(ro.RegionName);
                            setDeleteModalOpen(true);
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Pagination */}
          {regionList.length > 0 && (
            <TablePagination
              component="div"
              count={regionList.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          )}
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Region</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the region{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {regionName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={deleteLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteRegion}
            color="error"
            disabled={deleteLoading}
            variant="contained"
          >
            {deleteLoading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TableComponent;
